module.exports = __webpack_public_path__ + "static/blackDiamond-08109a3a4c8a42457e946c7fa1f1f383.svg";